import {Box} from "@mui/material";
import * as React from "react";

interface Props {
    children: React.ReactNode;
}

/** Preserves maximum observed height to prevent layout jumps when content shrinks. */
export function KeepTallest({children}: Props) {
    const ref = React.useRef<HTMLDivElement>(null);
    const [heights, setHeights] = React.useState({current: 0, tallest: 0});

    React.useLayoutEffect(() => {
        const element = ref.current;
        if (element == null) return;

        const observer = new ResizeObserver(entries => {
            const height = entries[0].contentRect.height;
            setHeights(previous => ({current: height, tallest: Math.max(previous.tallest, height)}));
        });
        observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return (
        <React.Fragment>
            <Box ref={ref} sx={{minWidth: 0}}>{children}</Box>

            <Box aria-hidden sx={{height: Math.max(0, heights.tallest - heights.current)}}/>
        </React.Fragment>
    );
}
